import * as React from 'react';

import { flashSuccess } from '../../flash';
import CreateOfferButton from '@reverbdotcom/commons/dist/offers/create_offer_button';
import bind from '@reverbdotcom/commons/dist/bind';

interface IProps {
  listingId: string;
  listingThumbnail?: string;
}

// This is a wrapper to export to core so that we can pass the offer flash callback function.
// Once we update the item page to no longer be a Frankenstein between core/FE then we can
// rip this out. :sigh:
export default class OfferButtonWithFlash extends React.Component<IProps, null> {
  @bind
  onOfferSuccess(message) {
    flashSuccess(message);
  }

  render() {
    return (
      <CreateOfferButton
        listingId={this.props.listingId}
        onOfferSuccess={this.onOfferSuccess}
        listingThumbnail={this.props.listingThumbnail}
      />
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/offers/offer_button_with_flash.tsx